import React, { useEffect, useState } from 'react';

const SimulatedVerification = ({ visible, setStatusMessage }) => {
  const [verificationStage, setVerificationStage] = useState(0);

  useEffect(() => {
    if (!visible) return;

    let timeout;

    switch (verificationStage) {
      case 0:
        timeout = setTimeout(() => setVerificationStage(1), 1000);
        break;
      case 1:
        timeout = setTimeout(() => setVerificationStage(2), 2500);
        break;
      case 2:
        timeout = setTimeout(() => setVerificationStage(3), 1000);
        break;
      case 3:
        timeout = setTimeout(() => {
          setVerificationStage(4);
          setStatusMessage('purchase-otp-verification');
        }, 2500);
        break;
      default:
        break;
    }

    return () => clearTimeout(timeout);
  }, [verificationStage, visible, setStatusMessage]);

  if (!visible || verificationStage === 4) return null;

  return (
    <div className="sim-loader-overlay">
      {verificationStage === 1 && (
        <div className="sim-center-spinner">
          <div className="sim-solid-spinner"></div>
        </div>
      )}
      {verificationStage === 3 && (
        <div className="sim-center-spinner">
          <div className="sim-dotted-spinner">
            <span></span><span></span><span></span>
          </div>
        </div>
      )}

      <style>{`
        .sim-loader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: white;
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .sim-center-spinner {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .sim-solid-spinner {
          width: 40px;
          height: 40px;
          border: 5px solid #eee;
          border-top-color: #219653;
          border-radius: 50%;
          animation: sim-spin 1s linear infinite;
        }

        .sim-dotted-spinner span {
          width: 10px;
          height: 10px;
          margin: 0 5px;
          background-color: #219653;
          border-radius: 50%;
          display: inline-block;
          animation: sim-bounce 0.6s infinite alternate;
        }

        .sim-dotted-spinner span:nth-child(2) {
          animation-delay: 0.2s;
        }

        .sim-dotted-spinner span:nth-child(3) {
          animation-delay: 0.4s;
        }

        @keyframes sim-spin {
          to { transform: rotate(360deg); }
        }

        @keyframes sim-bounce {
          from { transform: translateY(0); opacity: 0.5; }
          to { transform: translateY(-10px); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default SimulatedVerification;
